const headerGroup = document.querySelector('#header-group');
const announceSection = document.querySelector('.ssc-announce')?.closest('.shopify-section');
if (headerGroup && announceSection && headerGroup.contains(announceSection)) {
  headerGroup.parentElement.insertBefore(announceSection, headerGroup);
}
headerGroup?.classList.add('ssc-sticky-header');

const sscHeader = document.querySelector('[data-ssc-header]');
function setHeaderHeight() {
  if (!sscHeader) return;
  const height = Math.round(sscHeader.getBoundingClientRect().height);
  document.documentElement.style.setProperty('--ssc-header-h', `${height}px`);
}
setHeaderHeight();

function sscParkStars(root) {
  (root || document).querySelectorAll('product-card').forEach((card) => {
    const gallery = card.querySelector('.card-gallery');
    const rating = card.querySelector('.ssc-card-rating');
    if (!gallery || !rating || !rating.querySelector('.ssc-stars')) return;
    if (rating.parentElement !== gallery) gallery.appendChild(rating);
  });
}
sscParkStars();
document.addEventListener('shopify:section:load', (event) => sscParkStars(event.target));
if (sscHeader && 'ResizeObserver' in window) {
  new ResizeObserver(setHeaderHeight).observe(sscHeader);
}

const menu = document.querySelector('[data-ssc-menu]');
const menuOpen = document.querySelector('[data-ssc-menu-open]');
if (menu && menu.parentElement !== document.body) document.body.appendChild(menu);
let menuReturn = null;

function menuFocusables() {
  if (!menu) return [];
  return [...menu.querySelectorAll('a, button, input, select, textarea')].filter((el) => !el.closest('[hidden]') && el.offsetParent !== null);
}

function openMenu() {
  if (!menu || !menuOpen) return;
  menuReturn = document.activeElement;
  menu.hidden = false;
  menuOpen.setAttribute('aria-expanded', 'true');
  document.documentElement.classList.add('ssc-scroll-lock');
  const close = menu.querySelector('[data-ssc-menu-close]');
  if (close) close.focus();
}

function closeMenu() {
  if (!menu || !menuOpen) return;
  menu.hidden = true;
  menuOpen.setAttribute('aria-expanded', 'false');
  document.documentElement.classList.remove('ssc-scroll-lock');
  menu.querySelectorAll('[data-ssc-panel]').forEach((panel) => {
    panel.hidden = panel.dataset.sscPanel !== 'root';
  });
  if (menuReturn && menuReturn.focus) menuReturn.focus();
}

// Menu and desktop dropdown images are lazy (both are hidden on load). Start them as soon as
// the visitor reaches for the menu button (mobile) or the header (desktop), so the tiles are
// filled by the time they open. Desktop also loads them once the page is idle.
function warmImages(root) {
  root?.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
}
['pointerenter', 'touchstart', 'focus'].forEach((type) => {
  menuOpen?.addEventListener(type, () => warmImages(menu), { once: true, passive: true });
});
sscHeader?.addEventListener('pointerenter', () => warmImages(document.querySelector('[data-ssc-nav]')), { once: true, passive: true });
window.addEventListener('load', () => {
  (window.requestIdleCallback || setTimeout)(() => {
    if (window.matchMedia('(min-width: 990px)').matches) warmImages(document.querySelector('[data-ssc-nav]'));
  });
}, { once: true });

menuOpen?.addEventListener('click', openMenu);
menu?.querySelector('[data-ssc-menu-close]')?.addEventListener('click', closeMenu);
menu?.querySelectorAll('[data-ssc-submenu]').forEach((button) => {
  button.addEventListener('click', () => {
    const id = button.dataset.sscSubmenu;
    menu.querySelectorAll('[data-ssc-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.sscPanel !== id;
    });
    menu.querySelector(`[data-ssc-panel="${id}"] [data-ssc-menu-back]`)?.focus();
  });
});
menu?.querySelectorAll('[data-ssc-menu-back]').forEach((button) => {
  button.addEventListener('click', () => {
    menu.querySelectorAll('[data-ssc-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.sscPanel !== 'root';
    });
    menuOpen.focus();
  });
});

const desktopNav = window.matchMedia('(min-width: 990px)');
const nav = document.querySelector('[data-ssc-nav]');
let megaTimer = null;

function closeMegas(except) {
  let closed = false;
  document.querySelectorAll('[data-ssc-mega]').forEach((panel) => {
    if (panel === except) return;
    if (!panel.hidden) closed = true;
    panel.hidden = true;
    const button = document.querySelector(`[aria-controls="${panel.id}"]`);
    if (button) button.setAttribute('aria-expanded', 'false');
  });
  return closed;
}

function openMega(item, focusFirst) {
  if (!desktopNav.matches || !item) return;
  const panel = item.querySelector('[data-ssc-mega]');
  if (!panel) return;
  closeMegas(panel);
  panel.hidden = false;
  item.querySelector('[data-ssc-mega-open]')?.setAttribute('aria-expanded', 'true');
  if (focusFirst) panel.querySelector('a')?.focus();
}

document.querySelectorAll('[data-ssc-mega-item]').forEach((item) => {
  item.addEventListener('mouseenter', () => {
    clearTimeout(megaTimer);
    openMega(item, false);
  });
  item.addEventListener('mouseleave', () => {
    clearTimeout(megaTimer);
    megaTimer = setTimeout(() => closeMegas(), 200);
  });
  item.querySelector('[data-ssc-mega-open]')?.addEventListener('click', () => {
    const panel = item.querySelector('[data-ssc-mega]');
    if (panel?.hidden) openMega(item, false);
    else closeMegas();
  });
});

document.addEventListener('click', (event) => {
  if (!event.target.closest('[data-ssc-mega-item]')) closeMegas();
});

nav?.addEventListener('keydown', (event) => {
  const tops = [...nav.querySelectorAll(':scope > ul > li > a, :scope > ul > li > button')];
  const current = event.target;
  const panel = current.closest?.('[data-ssc-mega]');
  if (panel && ['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].includes(event.key)) {
    const tiles = [...panel.querySelectorAll('a')];
    const index = tiles.indexOf(current);
    if (index < 0) return;
    event.preventDefault();
    const cols = 4;
    if (event.key === 'ArrowRight') tiles[Math.min(tiles.length - 1, index + 1)].focus();
    if (event.key === 'ArrowLeft') tiles[Math.max(0, index - 1)].focus();
    if (event.key === 'ArrowDown') tiles[Math.min(tiles.length - 1, index + cols)].focus();
    if (event.key === 'ArrowUp') {
      if (index < cols) {
        closeMegas();
        current.closest('[data-ssc-mega-item]')?.querySelector('button')?.focus();
      } else {
        tiles[index - cols].focus();
      }
    }
    return;
  }
  const index = tops.indexOf(current);
  if (index < 0) return;
  if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
    event.preventDefault();
    const next = event.key === 'ArrowRight' ? Math.min(tops.length - 1, index + 1) : Math.max(0, index - 1);
    closeMegas();
    tops[next].focus();
    if (tops[next].hasAttribute('data-ssc-mega-open')) openMega(tops[next].closest('[data-ssc-mega-item]'), false);
  }
  if (event.key === 'ArrowDown' && current.hasAttribute('data-ssc-mega-open')) {
    event.preventDefault();
    openMega(current.closest('[data-ssc-mega-item]'), true);
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && closeMegas()) {
    event.preventDefault();
    return;
  }
  if (event.key === 'Escape' && menu && !menu.hidden) {
    event.preventDefault();
    closeMenu();
  }
  if (event.key !== 'Tab' || !menu || menu.hidden) return;
  const items = menuFocusables();
  if (!items.length) return;
  const first = items[0];
  const last = items[items.length - 1];
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
});

const search = document.querySelector('[data-ssc-search]');
document.querySelector('[data-ssc-search-open]')?.addEventListener('click', () => {
  const modal = document.querySelector('#search-modal');
  if (modal && typeof modal.showDialog === 'function') {
    modal.showDialog();
    return;
  }
  if (!search) return;
  search.hidden = !search.hidden;
  if (!search.hidden) search.querySelector('input')?.focus();
});

function paintMeter(total) {
  document.querySelectorAll('[data-ssc-ship-meter]').forEach((meter) => {
    if (meter.dataset.vip === 'member') return; // US VIP: "US shipping FREE · VIP", nothing to count
    const threshold = Number(meter.dataset.threshold || 5900);
    const text = meter.querySelector('[data-ssc-ship-text]');
    const fill = meter.querySelector('[data-ssc-ship-fill]');
    const remaining = Math.max(0, threshold - total);
    const pct = Math.min(100, Math.round((total / threshold) * 100));
    if (fill) fill.style.width = `${pct}%`;
    meter.classList.toggle('is-unlocked', remaining <= 0); // drawer: unlocked = one green line, no bar (prompt 89)
    if (!text) return;
    if (remaining <= 0) {
      text.textContent = 'Free shipping unlocked';
    } else {
      const dollars = (remaining / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }).replace(/\.00$/, '');
      const vipUrl = meter.dataset.vipUrl;
      if (vipUrl) {
        // VIP Pass (C4): one line, no pop-up. Only on the US storefront (data-vip-url is set there only).
        text.innerHTML = '';
        const line = document.createElement('span');
        line.append(`Add ${dollars} for free shipping, or get `);
        const b = document.createElement('b');
        b.textContent = 'free US shipping on every order';
        line.append(b, ' with VIP.');
        const link = document.createElement('a');
        link.className = 'ssc-ship-meter__vip';
        link.href = vipUrl;
        link.textContent = 'See VIP';
        text.append(line, ' ', link);
      } else {
        text.textContent = `You're ${dollars} away from free shipping`;
      }
    }
  });
  document.querySelectorAll('[data-ssc-cart-count]').forEach((node) => {
    const count = document.querySelector('[data-ssc-cart-count]');
    if (!count) return;
  });
}

async function refreshMeter() {
  const cart = await fetch('/cart.js').then((response) => response.json());
  // Shipping protection (prompt 102) doesn't count in the meter or the cart count. The Kit Customization fee (prompt 132)
  // counts toward free shipping (Shopify's free shipping counts it) but not in the cart count.
  let count = cart.item_count || 0;
  let total = cart.total_price || 0;
  (cart.items || []).forEach((item) => {
    if (item.handle === 'kit-customization') {
      count -= item.quantity || 0;
      return;
    }
    if (item.handle !== 'shipping-protection') return;
    count -= item.quantity || 0;
    total -= item.final_line_price || 0;
  });
  count = Math.max(0, count);
  paintMeter(Math.max(0, total));
  document.querySelectorAll('[data-ssc-cart-count]').forEach((node) => {
    node.textContent = String(count);
    node.classList.toggle('ssc-cart-count--empty', !count);
  });
}

document.querySelector('[data-ssc-cart-open]')?.addEventListener('click', () => {
  const drawer = document.querySelector('#cart-drawer');
  if (drawer && typeof drawer.open === 'function') drawer.open();
  else window.location.href = '/cart';
});

document.addEventListener('shopify:cart:lines-update', (event) => {
  refreshMeter();
  if (!event.promise || typeof event.promise.then !== 'function') return;
  event.promise.then((payload) => {
    refreshMeter();
    if (payload?.detail?.didError) return;
    if (payload?.detail?.source !== 'product-form-component') return;
    document.getElementById('quick-add-dialog')?.closeDialog?.();
  }).catch(() => {});
});

const scrim = document.createElement('div');
scrim.className = 'ssc-scrim';
scrim.hidden = true;
document.body.appendChild(scrim);

function syncScrim() {
  const menuOpen = menu && !menu.hidden;
  const cartOpen = document.querySelector('#cart-drawer')?.hasAttribute('open');
  scrim.hidden = !(menuOpen || cartOpen);
}

scrim.addEventListener('click', () => {
  if (menu && !menu.hidden) closeMenu();
  const drawer = document.querySelector('#cart-drawer');
  if (drawer?.hasAttribute('open') && typeof drawer.close === 'function') drawer.close();
});

document.addEventListener('theme-drawer:open', syncScrim);
document.addEventListener('theme-drawer:close', syncScrim);
const menuObserver = new MutationObserver(syncScrim);
if (menu) menuObserver.observe(menu, { attributes: true, attributeFilter: ['hidden'] });
// Desktop: Horizon re-opens a drawer left open on the previous page (inline restore script in theme-drawer.liquid)
// without firing theme-drawer:open, so sync once here or the restored drawer has no scrim and a page click can't close it.
syncScrim();

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

document.querySelectorAll('[data-ssc-row]').forEach((row) => {
  const track = row.querySelector('[data-ssc-row-track]');
  if (!track) return;
  // Prompt 124: one card per click (it used to move 0.8 of the row, several cards).
  const scrollByCard = (direction) => {
    const item = track.querySelector('.ssc-row__item, .ssc-recent__item');
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const step = item ? item.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    track.scrollBy({ left: direction * step, behavior: reduceMotion ? 'auto' : 'smooth' });
  };
  row.querySelector('[data-ssc-row-prev]')?.addEventListener('click', () => scrollByCard(-1));
  row.querySelector('[data-ssc-row-next]')?.addEventListener('click', () => scrollByCard(1));
});

document.querySelectorAll('[data-ssc-hero-pause]').forEach((button) => {
  const video = button.closest('[data-ssc-hero]')?.querySelector('video');
  if (!video) return;
  button.addEventListener('click', () => {
    if (video.paused) {
      video.play();
      button.setAttribute('aria-label', 'Pause');
    } else {
      video.pause();
      button.setAttribute('aria-label', 'Play');
    }
  });
});
